import { cardPageController } from 'magner';
import { baseT } from 'configs/translation/base';
import { discountsT } from './index';
import { get, create, update } from './requests';
import type { ReadTransformed } from './types';
import { searchBreedAll } from '~/utils/searchInit';

import DiscountType from './components/discounts-type.vue';
import DiscountsSelector from './components/discounts-selector.vue';
import DiscountsPromo from './components/discounts-promo.vue';
import DiscountsObject from './components/discounts-object.vue';
import DiscountAudience from './components/discounts-audience.vue';
import DiscountValidPeriod from './components/discounts-valid-period.vue';
import DiscountPetAge from './components/discounts-pet-age.vue';

export const cardConfig = cardPageController<ReadTransformed>({
  header: {
    title: discountsT('card.title'),
  },

  getRequest: get,
  updateRequest: update as any,
  createRequest: create as any,

  form: {
    fullDataOnUpdate: true,
    actions: [
      {
        type: 'link',
        to: () => ({ name: 'discounts' }),
        props: {
          text: baseT('form.back_button'),
          class: 'width-auto',
        },
      },
      {
        type: 'link',
        to: (route): any => ({ name: 'discounts-edit', params: { route } }),
        props: {
          text: baseT('form.edit_button'),
          class: 'width-auto',
          type: 'primary',
        },
      },
    ],

    layout: {
      type: 'row',
      props: {},
      layout: [
        /** Left column */
        {
          type: 'column',
          props: {
            span: 12,
            xs: 24,
            styles: { 'padding-right': '12px' },
          },
          layout: [
            /** Code, isActive */
            {
              type: 'row',
              props: {
                justify: 'space-between',
                elementsGrow: true,
                styles: { gap: '12px', flexWrap: 'nowrap' },
              },
              fields: [
                {
                  type: 'input',
                  name: 'id',
                  dataType: 'string',
                  props: {
                    hidden: true,
                  },
                },
                {
                  type: 'input',
                  name: 'code',
                  label: 'Название служебное',
                  dataType: 'string',
                  props: {
                    readOnly: true,
                  },
                },
                {
                  type: 'input',
                  name: 'active',
                  label: 'Статус',
                  dataType: 'string',
                  props: {
                    readOnly: true,
                    readOnlyFormatter: (val) => (val === 'active' ? 'Активен' : 'Неактивен'),
                  },
                },
              ],
            },
            /** Caption */
            {
              type: 'column',
              props: {},
              fields: [
                {
                  type: 'input',
                  name: 'caption',
                  label: 'Название рекламное',
                  dataType: 'string',
                  props: {
                    readOnly: true,
                  },
                },
              ],
            },
            /** City */
            {
              type: 'column',
              props: {},
              fields: [
                {
                  type: 'select',
                  name: 'city',
                  options: [],
                  label: baseT('label.city'),
                  dataType: 'string',
                  props: {
                    readOnly: true,
                    readOnlyFormatter: (val) => val?.name,
                  },
                },
              ],
            },
            /** Date */
            {
              type: 'column',
              props: {},
              fields: [
                {
                  type: 'custom',
                  name: 'validPeriod',
                  label: 'Размер скидки',
                  props: {
                    readOnly: true,
                  },
                  component: () => DiscountValidPeriod,
                },
                {
                  type: 'datetime',
                  name: 'validPeriodDate',
                  dataType: 'date',
                  props: {
                    type: 'datetimerange',
                    startPlaceholder: 'От',
                    endPlaceholder: 'До',
                    format: 'YYYY-MM-DD HH:mm',
                    rangeSeparator: '–',
                    disabled: true,
                  },
                },
              ],
            },
            /** Type and value discount */
            {
              type: 'row',
              props: {
                justify: 'space-between',
                elementsGrow: true,
                styles: { gap: '12px', flexWrap: 'nowrap' },
              },
              fields: [
                {
                  type: 'custom',
                  name: 'type',
                  label: 'Размер скидки',
                  props: {
                    readOnly: true,
                  },
                  component: () => DiscountType,
                },
                {
                  type: 'input',
                  name: 'value',
                  label: '\u0000',
                  dataType: 'string',
                  props: {
                    readOnly: true,
                  },
                  validation: [
                    {
                      type: 'empty-required' as 'empty',
                      trigger: 'blur',
                    },
                  ],
                },
              ],
            },
            /** Release */

            /** Size discount */
            {
              type: 'row',
              props: {
                justify: 'space-between',
                elementsGrow: true,
                styles: { gap: '12px', flexWrap: 'nowrap' },
              },
              fields: [
                {
                  type: 'custom',
                  name: 'promoType',
                  label: 'Реализация',
                  props: {
                    readOnly: true,
                  },
                  component: () => DiscountsPromo,
                  changeAction: ({ form }) => {
                    form.promo = null;
                  },
                },
                {
                  type: 'input',
                  name: 'promo',
                  label: '\u0000',
                  dataType: 'string',
                  props: {
                    readOnly: true,
                  },
                },
              ],
            },
            {
              type: 'column',
              title: 'Объект скидки',
              props: {
                span: 24,
                isPaper: true,
                titleType: 'heading',
              },
              layout: [
                /** Name, status */
                {
                  type: 'row',
                  props: {
                    justify: 'space-between',
                    elementsGrow: true,
                    styles: { gap: '12px', flexWrap: 'nowrap' },
                  },
                  layout: [
                    {
                      type: 'column',
                      props: {},
                      fields: [
                        {
                          type: 'custom',
                          name: 'objectData',
                          props: {
                            readOnly: true,
                          },
                          component: () => DiscountsObject,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },

        /** Right column */

        {
          type: 'column',
          props: {
            span: 12,
            xs: 24,
            styles: { 'padding-left': '12px' },
          },
          layout: [
            {
              type: 'column',
              title: 'Условия применения',
              props: {
                span: 24,
                isPaper: true,
                titleType: 'heading',
              },
              layout: [
                /** Name, status */
                {
                  type: 'row',
                  props: {
                    justify: 'space-between',
                    elementsGrow: true,
                    styles: { gap: '12px', flexWrap: 'nowrap' },
                  },
                  layout: [
                    {
                      type: 'column',
                      props: {},
                      fields: [
                        {
                          type: 'input',
                          name: 'minPrice',
                          label: 'Минимальная сумма заказа',
                          dataType: 'string',
                          props: {
                            type: 'number',
                            readOnly: true,
                          },
                        },
                        {
                          type: 'switch',
                          name: 'needMinPrice',
                          dataType: 'boolean',
                          props: {
                            activeLabel: 'Не требуется',
                            disabled: true,
                          },
                        },
                      ],
                    },
                    {
                      type: 'column',
                      props: {},
                      fields: [
                        {
                          type: 'input',
                          name: 'maxPrice',
                          label: 'Максимальная сумма заказа',
                          dataType: 'string',
                          props: {
                            type: 'number',
                            readOnly: true,
                          },
                        },
                        {
                          type: 'switch',
                          name: 'needMaxPrice',
                          dataType: 'boolean',
                          props: {
                            activeLabel: 'Не требуется',
                            disabled: true,
                          },
                        },
                      ],
                    },
                  ],
                },
                /** counter */
                {
                  type: 'column',
                  props: {},
                  fields: [
                    {
                      type: 'input',
                      name: 'maxApplyCount',
                      label: 'Многократное использование, количество раз',
                      dataType: 'string',
                      props: {
                        type: 'number',
                        readOnly: true,
                      },
                    },
                    {
                      type: 'switch',
                      name: 'needMaxApplyCount',
                      dataType: 'boolean',
                      props: {
                        activeLabel: 'Однократная скидка',
                        disabled: true,
                      },
                    },
                  ],
                },
                /** compatibility */
                {
                  type: 'column',
                  props: {},
                  fields: [

                    {
                      type: 'select',
                      name: 'compatibility',
                      options: [],
                      label: 'Совместимость с другими скидками',
                      dataType: 'string',
                      props: {
                        readOnly: true,
                        readOnlyFormatter: (val) => val?.label,
                      },
                    },
                  ],
                },
              ],
            },

            {
              type: 'column',
              title: 'Аудитория',
              props: {
                span: 24,
                isPaper: true,
                titleType: 'heading',
              },
              layout: [
                {
                  type: 'column',
                  props: {},
                  fields: [
                    {
                      type: 'custom',
                      name: 'audience',
                      props: {
                        required: true,
                        readOnly: true,
                      },
                      component: () => DiscountAudience,
                      changeAction: ({ form }) => {
                        if (form.audience !== 'clients') {
                          form.clients = [];

                          return;
                        } 

                        form.breeds = [];
                        form.breedsNone = false;
                        form.petAge = null;
                        form.petAgeNone = false;
                        form.onlyNewClients = false;
                      },
                    },
                    /* Audience segment */
                    // breeds
                    {
                      type: 'select',
                      name: 'breeds',
                      options: [],
                      label: 'Порода питомцев',
                      dataType: 'string',
                      props: {
                        hidden: ({ state }) => state.audience !== 'segment',
                        disabled: true,
                        remote: true,
                        multiple: true,
                        valueKey: 'id',
                        labelKey: 'title',
                        remoteMethod: searchBreedAll,
                      },
                    },
                    {
                      type: 'switch',
                      name: 'breedsNone',
                      dataType: 'boolean',
                      props: {
                        activeLabel: 'Любая порода',
                        hidden: ({ state }) => state.audience !== 'segment',
                        disabled: true,
                      },
                    },
                    // age
                    {
                      type: 'custom',
                      name: 'petAge',
                      label: 'Возраст питомцев',
                      props: {
                        readOnly: true,
                        hidden: ({ state }) => state.audience !== 'segment',
                      },
                      component: () => DiscountPetAge,
                    },
                    {
                      type: 'switch',
                      name: 'petAgeNone',
                      dataType: 'boolean',
                      props: {
                        activeLabel: 'Любой возраст',
                        hidden: ({ state }) => state.audience !== 'segment',
                        disabled: true,
                      },
                    },
                    // is new client
                    {
                      type: 'switch',
                      name: 'onlyNewClients',
                      dataType: 'boolean',
                      props: {
                        activeLabel: 'Заказов еще не было',
                        hidden: ({ state }) => state.audience !== 'segment',
                        disabled: true,
                      },
                    },

                    /* Clients segment */
                    {
                      type: 'custom',
                      name: 'clients',
                      component: () => DiscountsSelector,
                      props: {
                        hidden: ({ state }) => state.audience !== 'clients',
                        readOnly: true,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  },
});
